import React, { Component } from 'react'
import JsonRender from './JsonRender'
import { BigModal } from 'components/basic'
import http from 'API/http'

class MethodRunner extends Component {
  constructor(props) {
    super(props)
    this.state = {
      error: false,
      response: false,
      loading: false,
      modal: false,
      method: null,
      response: null
    }
  }
  componentDidMount () {
    this.props.setMethod(this.setMethod.bind(this))
    this.setState({accessId: this.props.accessId})
  }

  setMethod (method) {
    this.setState({method: method, modal: true})
  }
  componentWillReceiveProps (props) {
    if (props.accessId === this.props.accessId) return
    this.setState({ accessId: props.accessId })
  }

  async runMethod () {
    this.setState({loading: true, response: null})
    var [err, res] = await http.get('troubleshoot/run', {id: this.state.accessId, methodId: this.state.method.id})
    if (err) return this.setState({loading: false, error: true, modal: true, errorMessage: res.cause})
    this.setState({loading: false, response: res.data, modal: true, error: false})
  }
  render () {
    if (!this.state.method) return false
    return (
      <BigModal icon='cog' title={'Run method ' + this.state.method.name} isOpen={this.state.modal} close={e => this.setState({modal: false, method: {}, response: false, error: false, errorMessage: false})} buttons={[
        { disabled: this.state.loading, hidden: this.state.running, icon: (this.state.loading ? 'circle-o-notch fa-spin' : 'play'), text: 'Run Method', event: () => this.runMethod() }
      ]}>
        {this.state.method.description &&
          <div>
            <label>Desription</label>
            <pre>{this.state.method.description}</pre>
          </div>
        }
        <div>
          {this.state.error &&
            <div>
              <hr/>
              <span className='label label-danger'><i className='fa fa-fw fa-exclamation-triangle' /> Error running method</span>
              <pre className='mt-10'>{this.state.errorMessage}</pre>
            </div>
          }
          {this.state.response &&
            <div>
              <hr/>
              <span className='label label-success'><i className='fa fa-fw fa-exclamation-triangle' /> Response</span>
              <JsonRender data={this.state.response} updated={this.state.updated} />
            </div>
          }
        </div>
      </BigModal>
    )
  }
}

export default MethodRunner



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/troubleshooting/MethodRunner.js